const SMALL_NUMBER_OF_FILES = 100;
const MEDIUM_NUMBER_OF_FILES = 1_000;
const SMALL_NUMBER_OF_FILES_REFETCH_INTERVAL = 10_000;
const MEDIUM_NUMBER_OF_FILES_REFETCH_INTERVAL = 30_000;
export const getDirContentsRefetchInterval = (entryCount) => {
    if (entryCount === undefined) {
        return false;
    }
    else if (entryCount < SMALL_NUMBER_OF_FILES) {
        return SMALL_NUMBER_OF_FILES_REFETCH_INTERVAL;
    }
    else if (entryCount < MEDIUM_NUMBER_OF_FILES) {
        return MEDIUM_NUMBER_OF_FILES_REFETCH_INTERVAL;
    }
    else {
        return false;
    }
};
